import { toast } from "react-toastify";

toast.configure();

export const success = (message, align = "bottom-center", time = 5000) => {
  toast.success(message, {
    position: align,
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const error = (message, align = "bottom-center", time = 5000) => {
  toast.error(message, {
    position: align,
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const info = (message, align = "bottom-center", time = 7000) => {
  toast.info(message, {
    position: align,
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const warning = (message, align = "bottom-center", time = 7000) => {
  toast.warn(message, {
    position: align,
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

const Note = {
  success,
  error,
  info,
  warning,
};

export default Note;
